<script>
    import {
        RESIDENCIAL_CATEGORIES,
        TRIPLEPLAY_CATEGORIES,
    } from '../utils/constant';
    import { getStaticVel } from '../utils/utils';

    export let vel, category;

    $: staticVel = getStaticVel(category, vel) ?? vel;

    $: shouldShowPromotionDuration =
        staticVel !== vel &&
        (TRIPLEPLAY_CATEGORIES.has(category) ||
            RESIDENCIAL_CATEGORIES.has(category));
</script>

<div class="plan-card__service plan-card__service--wifi">
    <svg class="plan-card__icon">
        <use xlink:href="/assets/img/icons/symbol-defs.svg#icon-wifi"></use>
    </svg>
    <p class="plan-card__text">
        {#if staticVel !== vel}
            de {vel} a<br />
        {/if}
        <span class="plan-card__highlight">{staticVel} megas</span>
        {#if shouldShowPromotionDuration}
            <br />durante 6 meses
        {/if}
    </p>
</div>
